export const prerenderOnMount = () => {
  window.prerenderReady = true
}
